import {
    GETWALLETTRANSACTIONLISTBYID_SUCCESS,
    GETWALLETTRANSACTIONLISTBYID_FAILED,
    RESET_GETWALLETTRANSACTIONLISTBYID,
    LOADING_GETWALLETTRANSACTIONLISTBYID,
    NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID,
} from "../types";
import { partnerServices } from "../../config/axios";


function resetGETWALLETTRANSACTIONLISTBYID() {
    return {
        type: RESET_GETWALLETTRANSACTIONLISTBYID,
    };
}

const getWalletTransactionListByIDs =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETWALLETTRANSACTIONLISTBYID });
        await partnerServices
            .post("getWalletTransactionListById", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getWalletTransactionListByIdsuccess(res.data));
                        break;
                    default:
                        dispatch(getWalletTransactionListByIdFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID,
                    payload: err
                });
            });
    };
function getWalletTransactionListByIdsuccess(data) {
    return {
        type: GETWALLETTRANSACTIONLISTBYID_SUCCESS,
        payload: data
    };
}
function getWalletTransactionListByIdFailed(data) {
    return {
        type: GETWALLETTRANSACTIONLISTBYID_FAILED,
        payload: data
    };
}

export { getWalletTransactionListByIDs, resetGETWALLETTRANSACTIONLISTBYID };
